import React, { useEffect, useState, useContext } from 'react';
import { Typography } from '@mui/material';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import { MsalContext } from '../Contexts/MsalContext';

interface INuisanceCallProps {
    systemPK: string,
}

export default function NuisanceCall({ systemPK }: INuisanceCallProps) {
    const { msalFetch } = useContext(MsalContext);
    const [rtm, setRtm] = useState<any>(null);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        msalFetch('api/Info/GetRtm?systemPk=' + encodeURIComponent(systemPK))
            .then((Response) => Response.json())
            .then((Data) => {
                setRtm(Data);
                setLoaded(true);
            });
    }

    const nuisanceCallClick = () => {
        msalFetch('api/info/AddRtm?systemPk=' + encodeURIComponent(systemPK) + '&ansMachine=0')
            .then((Response) => fetchData());
    }

    const answerMachineClick = (e) => {
        msalFetch('api/info/AddRtm?systemPk=' + encodeURIComponent(systemPK) + '&ansMachine=1')
            .then((Response) => fetchData());
    }

    return (
        loaded ?
            <Grid style={{ backgroundColor: '#fff', padding: '8px', height: '100%' }}>
                <Typography variant="subtitle1" gutterBottom>This call is currently marked as: {rtm === null ? "Unmarked" : rtm.ansMachine === 1 ? "Answer Machine" : "Nuisance Call"}</Typography>

                <Button variant="contained" color="secondary" style={{ marginRight: '8px' }} onClick={nuisanceCallClick}>Nuisance Call</Button>
                <Button variant="contained" color="secondary" style={{ marginRight: '8px' }} onClick={answerMachineClick}>Answer Machine</Button>
            </Grid>
            :
            <React.Fragment />
    );
}